import React from 'react';
import css from './Spinner.scss';

const Spinner: React.FC<{}> = (props) => (
    <div style={{minHeight: '700px'}}>
        <div className={css.loading}>Loading&#8230;</div>
    </div>
);
export default Spinner;
